<template>
    <div key="clipboardSuccess" v-if="showSuccessMessage">
        <slot name="success" />
    </div>

    <div key="clipboardLink" v-else v-clipboard:copy="content" v-clipboard:success="onCopy">
        <slot name="link" />
    </div>
</template>

<script>
    export default {
        props: {
            content: { type: String, required: true },
        },

        data() {
            return { showSuccessMessage: false }
        },

        methods: {
            onCopy() {
                this.showSuccessMessage = true

                setTimeout(() => this.showSuccessMessage = false, 3000)
            }
        }
    }
</script>